.assistant-action-bar {
  display: flex;
  gap: var(--mantine-spacing-sm);
  padding: var(--mantine-spacing-xs);
}
